/*
  What GET /mobile-app actually answers with. The backend builds the document
  out of whatever the restaurant has saved: `venue` and `color` are left out
  entirely until something is stored, and empty fields inside them are dropped
  one by one, so no level of this can be assumed present. `tipFeeBps` is the
  exception — it always comes back — which is why "the response has keys" is
  not the same as "the venue has branding".
*/
type MobileAppDataModel = {
  tipFeeBps?: number
  venue?: {
    name?: string
    websiteText?: string
    websiteUrl?: string
  }
  color?: {
    primary?: string
    secondary?: string
    tertiary?: string
    background?: string
  }
}

/*
  What the form sends back. The form always has a value for every field, so the
  payload is complete even though the endpoint accepts a partial one.
  `tipFeeBps` is absent on purpose: it is the platform's rate, negotiated on the
  tenant, and the endpoint rejects it on the way in.
*/
type MobileAppBrandingPayload = {
  venue: {
    name: string
    websiteText: string
    websiteUrl: string
  }
  color: {
    primary: string
    secondary: string
    tertiary: string
    background: string
  }
}

enum QUERY {
  MOBILE_APP_DATA = 'mobileAppData',
  // Shared with the restaurant settings, the one place the logo is set.
  LOGO = 'logo'
}

export { QUERY }
export type { MobileAppBrandingPayload, MobileAppDataModel }
